import { ScrollArea, Space } from '@mantine/core';
import { any } from 'lodash/fp';
import React, { useMemo } from 'react';

import { OrderType } from '@portals/api/partners';
import { useGenericContext } from '@portals/framework';

import { OrderProductSummaryRow } from './OrderProductSummaryRow';

export function OrderProductsSummary() {
  const order = useGenericContext<OrderType>();

  const withSku = useMemo(
    () =>
      any(
        (orderItem: OrderType['items'][number]) =>
          Boolean(orderItem.product.sku),
        order?.items
      ),
    [order?.items]
  );
  return (
    <ScrollArea.Autosize mah={430}>
      {(order?.items || [])?.map(
        (item: OrderType['items'][number], index: number) => (
          <OrderProductSummaryRow
            key={index}
            orderItem={item}
            index={index}
            withSku={withSku}
          />
        )
      )}

      <Space h="xs" />
    </ScrollArea.Autosize>
  );
}
